export default __webpack_public_path__ + "static/media/distribution.ce0cd22c.png";